import { createAction } from 'typesafe-actions';

import type { ImprovementsState } from './';
import {
  SET_ACTIONBOARD_SELECTED_ENTITY_ID,
  SET_ACTIONBOARD_SELECTED_WEEK,
  SET_ACTIVE_TAB_ID,
  SET_SELECTED_ACTION_ID,
  SET_SELECTED_AREA_IDS,
  SET_SELECTED_SUGGESTION_ID,
  START_ADD_ACTION,
  START_CREATE_ACTION_FROM_SUGGESTION,
  START_CREATE_MOCK_ACTION,
  START_CREATE_MOCK_SUGGESTION,
  START_DELETE_ACTION,
  START_DELETE_SUGGESTION,
  START_REJECT_SUGGESTION,
  START_SAVE_SUGGESTION,
  START_UPDATE_ACTION,
  TOGGLE_SELECTED_AREA_ID,
} from './constants';

export const setActiveTabId = createAction(
  SET_ACTIVE_TAB_ID,
  (payload: ImprovementsState['activeTabId']) => payload,
)();

// Filter-chip setters — replace the whole set or toggle a single id.
// toggle is the workhorse for chip clicks; setSelectedAreaIds is used by the
// "All" affordance to clear the filter.
export const setSelectedAreaIds = createAction(
  SET_SELECTED_AREA_IDS,
  (payload: ImprovementsState['selectedAreaIds']) => payload,
)();
export const toggleSelectedAreaId = createAction(
  TOGGLE_SELECTED_AREA_ID,
  (payload: string) => payload,
)();

// ==========================
// Actions Sagas / Actions
// ==========================

export const setSelectedActionId = createAction(
  SET_SELECTED_ACTION_ID,
  (payload: ImprovementsState['selectedActionId']) => payload,
)();
export const startUpdateAction = createAction(
  START_UPDATE_ACTION,
  (payload: { action: Data.Action }) => payload,
)();
export const startDeleteAction = createAction(
  START_DELETE_ACTION,
  (payload: { actionId: string }) => payload,
)();
export const startCreateMockAction = createAction(START_CREATE_MOCK_ACTION)();

export const startAddAction = createAction(
  START_ADD_ACTION,
  (payload: { action: Data.Action }) => payload,
)();

// ==========================
// Suggestions Sagas / Actions
// ==========================

export const setSelectedSuggestionId = createAction(
  SET_SELECTED_SUGGESTION_ID,
  (payload: ImprovementsState['selectedSuggestionId']) => payload,
)();

export const startCreateActionFromSuggestion = createAction(
  START_CREATE_ACTION_FROM_SUGGESTION,
  (payload: { suggestionId: string }) => payload,
)();

export const startSaveSuggestion = createAction(
  START_SAVE_SUGGESTION,
  (payload: Data.Suggestion) => payload,
)();

export const startCreateMockSuggestion = createAction(
  START_CREATE_MOCK_SUGGESTION,
)();

export const startRejectSuggestion = createAction(
  START_REJECT_SUGGESTION,
  (payload: { suggestionId: string }) => payload,
)();

export const startDeleteSuggestion = createAction(
  START_DELETE_SUGGESTION,
  (payload: { suggestionId: string }) => payload,
)();

// ==========================
// Actionboard (sub-view) / Actions
// ==========================
// Pure setters — actionboard has no saga, only synchronous selection state
// (selected week + selected entity for the simulate tab's KPI controls).
export const setActionboardSelectedWeek = createAction(
  SET_ACTIONBOARD_SELECTED_WEEK,
  (payload: Time.Week) => payload,
)();
export const setActionboardSelectedEntityId = createAction(
  SET_ACTIONBOARD_SELECTED_ENTITY_ID,
  (payload: null | string) => payload,
)();
